<script setup>
import { ref, defineProps, defineExpose, defineEmits, onMounted } from 'vue'
import { Loader } from "@googlemaps/js-api-loader"

const emit = defineEmits(['onClickMarker', 'onClickMarkerCost'])

const props = defineProps(['mapInfo', 'fields', 'activeField'])
const mapInfo = ref(props.mapInfo)

const searchKeyword = ref(null);

// GoogleMap関連
let map = null
let markers = null;

// マップ内の情報ウィンドウ定義
const Content = `<div class="custom-info">
                  <div class="custom-info-item name text-center"><h5><div class="badge d-grid" style="background-color:@NameColor@">@Name@</div></h5></div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item" style="padding:0;"><div class="custom-info-item crop"><i class="bi bi-tree-fill"></i> 作物：@Crop@</div></li>
                    <li class="list-group-item" style="padding:0;"><div class="custom-info-item prog"><i class="bi bi-calendar3"></i> 期間：@FromDT@～@ToDT@</div></li>
                    <li class="list-group-item" style="padding:0;"><div class="custom-info-item manager"><i class="bi bi-person-square"></i> 担当：@Manager@</div></li>
                    <li class="list-group-item" style="padding:0;"><div class="custom-info-item manager"><i class="bi bi-camera-video-fill"></i> Live ：@Live@</div></li>
                    <li class="list-group-item" style="padding:0;">&nbsp</li>
                    <button class="btn btn-sm btn-warning w-100" type="button" onclick="document.getElementById('inputTargetField').value='@id@'; document.getElementById('btnInfoDetail').click('')">
                      <i class="bi bi-info-circle"></i> 詳細情報
                    </button>
                  </ul>
                </div>`
// const Content = `<div class="custom-info">
//                   <div class="custom-info-item name text-center"><h5><div class="badge d-grid" style="background-color:@NameColor@">@Name@</div></h5></div>
//                   <ul class="list-group list-group-flush">
//                     <li class="list-group-item" style="padding:0;"><div class="custom-info-item crop"><i class="bi bi-tree-fill"></i> 作物：@Crop@</div></li>
//                     <li class="list-group-item" style="padding:0;"><div class="custom-info-item prog"><i class="bi bi-calendar3"></i> 期間：@FromDT@～@ToDT@</div></li>
//                     <li class="list-group-item" style="padding:0;"><div class="custom-info-item manager"><i class="bi bi-person-square"></i> 担当：@Manager@</div></li>
//                     <li class="list-group-item" style="padding:0;"><div class="custom-info-item manager"><i class="bi bi-camera-video-fill"></i> Live ：@Live@</div></li>
//                     <div class="btn-toolbar mx-auto p-2"" role="toolbar" aria-label="Toolbar with button groups">
//                       <div class="btn-group me-2" role="group" aria-label="First group">
//                         <button class="btn btn-sm btn-warning" type="button" onclick="document.getElementById('inputTargetField').value='@id@'; document.getElementById('btnInfoDetail').click('')">
//                           <i class="bi bi-info-circle"></i> 詳細
//                         </button>
//                       </div>
//                       <div class="btn-group me-2" role="group" aria-label="Second group">
//                         <button class="btn btn-sm btn-primary" type="button" onclick="document.getElementById('inputTargetFieldCost').value='@id@'; document.getElementById('btnInfoDetailCost').click('')">
//                           <i class="bi bi-clipboard-data"></i> 原価
//                         </button>
//                       </div>
//                       <div class="btn-group me-2" role="group" aria-label="Third group">
//                         <button class="btn btn-sm btn-primary" type="button" onclick="document.getElementById('inputTargetFieldGrowth').value='@id@'; document.getElementById('btnInfoDetailGrowth').click('')">
//                           <i class="bi bi-clipboard-data"></i> 生育
//                         </button>
//                       </div>
//                     </div>
//                   </ul>
//                 </div>`

onMounted(() => {
  initGoogleMap();
})

// マップ初期処理
function initGoogleMap() {
  const loader = new Loader({
    apiKey: process.env.VUE_APP_MAP_API_KEY,
    version: "weekly",//"Release"
    // libraries: ["places", "drawing", "geometry", "visualization"],    
    language: "ja",
  });

  loader.load().then(async () => {
    const { Map } = await window.google.maps.importLibrary("maps");

    // MAP生成
    map = new Map(document.getElementById("map"), {
      // 拡大率
      zoom: 17,
      // 中心の座標（圃場データ読み込み後に設定）
      //center: 
      // 地図タイプ（ROADMAP/SATELLITE/TERRAIN/HYBRID）
      mapTypeId: window.google.maps.MapTypeId.HYBRID,
      // 地図スタイル
      // styles: {},
      // 標準コントロールの無効化
      disableDefaultUI: false,
      // マップタイプ切り替えの表示
      mapTypeControl: true,
      // マップタイプ切り替えのオプション
      mapTypeControlOptions: {
        // スタイル（HORIZONTAL_BAR/DROPDOWN_MENU）
        style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        // 表示位置
        position: window.google.maps.ControlPosition.LEFT_TOP
      },
      // ズームコントロールの表示
      zoomControl: true,
      // ズームコントロールのオプション
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      // 長さの目安の表示
      scaleControl: false,
      // ストリートビュー切り替えの表示
      streetViewControl: true,
      // ストリートビュー切り替えのオプション
      streetViewControlOptions: {
        position: window.google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      // 全画面表示切り替え
      fullscreenControl: false,
      // マウスホイールの操作を有効にするか
      scrollwheel: true,
    });
    markers = new window.google.maps.MVCArray();

    // 圃場情報追加
    addFields(map);

    // 中心座標移動
    map.setCenter(props.fields[0].LatLng);
    map.panTo(props.fields[0].LatLng);
  });
}

// 圃場情報追加処理
function addFields(map) {
  props.fields.forEach(function(element){
    // Construct the polygon.
    const polygon = new window.google.maps.Polygon({
      paths: element.PolygonCoords,
      strokeColor: element.PolygonStrokeColor,
      strokeOpacity: 1,
      fillOpacity: 0,
    });
    polygon.setMap(map);

    // Construct the Marker.
    const marker = new window.google.maps.Marker({
      position: element.LatLng,
      map: map, 
      animation: window.google.maps.Animation.DROP,
      icon: {
        url: element.IconUrl,
        scaledSize: new window.google.maps.Size(60,60),
        labelOrigin: new window.google.maps.Point(30, 50),
      },
    });
    markers.push(marker);

    // 情報ウィンドウの内容を生成
    let content = Content;
    //content = content.replace('@id@', element.id);
    content = content.replace(/@id@/g, element.id);
    content = content.replace('@Name@', element.Name);
    content = content.replace('@NameColor@', element.PolygonStrokeColor);
    content = content.replace('@Crop@', element.Crop);
    content = content.replace('@FromDT@', element.FromDT);
    content = content.replace('@ToDT@', element.ToDT);
    content = content.replace('@Manager@', element.Manager);
    content = content.replace('@Live@', element.liveurl ? "On" : "Off");

    // Construct the InfoWindow.
    const infoWindow = new window.google.maps.InfoWindow({
      position: element.LatLng,
      content: content,
      pixelOffset: new window.google.maps.Size(0, -50),
      disableAutoPan: true
    })
    window.google.maps.event.addListener(marker, 'click', ()=>{
      infoWindow.open(map);
      // return onClickMarker(element);
    });
    infoWindow.open(map);

    // map.overlayMapTypes.push(getImageMapType(element.id, element.TileBounds, element.ShootingDays));
  });
}

// 
function getImageMapType(id, bounds, days, idx) {
  let date = null;

  if (days) {
    // 対象圃場の直近の撮影日を取得
    for (let i = 0; i < days.length; i++) {
      if (days[i] <= mapInfo.value.selectedDate) {
        date = days[i].toString();
        break;
      }
    }
  }

  // マーカーに撮影日ラベルをセット
  markers.getAt(idx).setLabel({
    text: (date && mapInfo.value.mapDataSW !== "Off") ? "撮影日：" + date.substr(0, 4) + "/" + date.substr(4, 2) + "/" + date.substr(6, 2) : ' ',
    // color: '#000000',
    className: 'map-marker-label',
    fontFamily: 'sans-serif',
    fontWeight: 'bold',
    fontSize: '12px',
  })

  // 撮影画像が無ければ処理終了
  if (!date) {
    return
  }

  var imageMapType = new window.google.maps.ImageMapType({
    getTileUrl: function(coord, zoom) {
      if (zoom < 12 || zoom > 24 ||
        bounds[zoom][0][0] > coord.x || coord.x > bounds[zoom][0][1] ||
        bounds[zoom][1][0] > coord.y || coord.y > bounds[zoom][1][1]) {
        return null
      }
      return "https://google-map-tiles.s3.ap-northeast-1.amazonaws.com"
      // return "/data/tile"
                + "/" + mapInfo.value.mapDataSW
                + "/" + id
                + "/" + date
                + "/" + mapInfo.value.mapType
                + "/" + zoom
                + "/" + coord.x
                + "/" + coord.y
                + ".png";
    },
    tileSize: new window.google.maps.Size(256, 256)
  });
  
  return imageMapType
}

// OpenWeatherMapレイヤー追加
function addOpenWeatherMap(type) {
  const weatherMapType = new window.google.maps.ImageMapType({
      getTileUrl: function(coord, zoom) {
        return "https://tile.openweathermap.org/map"
                  + "/" + type
                  + "/" + zoom
                  + "/" + coord.x
                  + "/" + coord.y
                  + ".png?appid=" + process.env.VUE_APP_OPEN_WEATHER_MAP_KEY;
      },
      tileSize: new window.google.maps.Size(256, 256),
      maxZoom: 25,  //表示する最大のズーム値
      minZoom: 1,  //表示する最小のズーム値
      name: 'openweathermap'
    });
    map.overlayMapTypes.push(weatherMapType);
}

// 20万分の1日本シームレス地質図
// https://gbank.gsj.jp/seamless/index.html
function addSeamlessMap() {
  map.overlayMapTypes.push(new window.google.maps.ImageMapType({
    getTileUrl : function( coord, zoom ) {
      return "https://gbank.gsj.jp/seamless/tilemap"
                + "/" + "basic"
                + "/" + "glfn"
                + "/" + zoom
                + "/" + coord.y
                + "/" + coord.x + '.png';
    },
    tileSize : new window.google.maps.Size( 256, 256 ),
    isPng : true,
    opacity : 0.6,
    minZoom : 1,
    maxZoom : 25
  }));
}

// Tomorrowレイヤー追加
function addTomorrow(type) {
  const TIMESTAMP = (new Date()).toISOString();
  const weatherMapType = new window.google.maps.ImageMapType({
      getTileUrl: function(coord, zoom) {
        return "https://api.tomorrow.io/v4/map/tile"
                  + "/" + zoom
                  + "/" + coord.x
                  + "/" + coord.y
                  + "/" + type //DATA_FIELD
                  + "/" + TIMESTAMP //TIMESTAMP
                  + ".png?apikey=" + process.env.VUE_APP_TOMORROW_KEY;
      },
      tileSize: new window.google.maps.Size(256, 256),
      maxZoom: 25,
      minZoom: 1,
      opacity: 0.5
    });
    map.overlayMapTypes.push(weatherMapType);
}

// マップ再描画処理
function reloadOverlay() {
  // オーバーレイクリア
  map.overlayMapTypes.clear();

  // OpenWatherLayer追加
  // 雲
  if (mapInfo.value.openWeatherLayer.cloud) { addOpenWeatherMap("clouds_new") }
  // 降水
  if (mapInfo.value.openWeatherLayer.precipitation) { addOpenWeatherMap("precipitation_new") }
  // 気温
  if (mapInfo.value.openWeatherLayer.temp) { addOpenWeatherMap("temp_new") }
  // 風速
  if (mapInfo.value.openWeatherLayer.wind) { addOpenWeatherMap("wind_new") }
  // 気圧
  if (mapInfo.value.openWeatherLayer.pressure) { addOpenWeatherMap("pressure_new") }

  // Tomorrowレイヤー追加
  // 雲
  if (mapInfo.value.tomorrowLayer.cloudCover) { addTomorrow("cloudCover") }
  // 降水
  if (mapInfo.value.tomorrowLayer.precipitationIntensity) { addTomorrow("precipitationIntensity") }
  // 気温
  if (mapInfo.value.tomorrowLayer.temperature) { addTomorrow("temperature") }
  // 風速
  if (mapInfo.value.tomorrowLayer.windSpeed) { addTomorrow("windSpeed") }
  // 気圧
  if (mapInfo.value.tomorrowLayer.pressureSeaLevel) { addTomorrow("pressureSeaLevel") }

  // 日本シームレス地質図レイヤー追加
  if (mapInfo.value.seamlessMap) { addSeamlessMap() }

  // 圃場追加
  props.fields.forEach(function(element, idx){
    let shootingDays = element.ShootingDays.find(e => e.id === mapInfo.value.mapDataSW);
    map.overlayMapTypes.push(getImageMapType(element.id, element.TileBounds, shootingDays?.Days, idx));
  });

  // OpenStreetMap
  // map.overlayMapTypes.push(new window.google.maps.ImageMapType({
  //   getTileUrl : function( coord, zoom ) {
  //     return "http://tile.openstreetmap.org/"
  //             + zoom + "/" + coord.x + "/" + coord.y + ".png";
  //   },
  //   tileSize : new window.google.maps.Size( 256, 256 ),
  //   isPng : true,
  //   // opacity : 0.5,
  //   minZoom : 1,
  //   maxZoom : 25
  // }));
}

// マップ上のマーカークリックイベント
function onClickMarker(field) {
  emit('onClickMarker', field);
}

// マップ上のマーカークリックイベント
function onClickMarkerCost(field) {
  emit('onClickMarkerCost', field);
}

// マップ上のマーカークリックイベント
function onClickMarkerGrowth(field) {
  emit('onClickMarkerGrowth', field);
}

// マップ中心座標移動処理
function moveMapCenter(latlng) {
  map.setCenter(latlng);
  map.panTo(latlng);
}

// 情報ウィンドウ内の詳細情報ボタンクリックイベント
function onClickInfoWindowButton() {
  // alert(document.getElementById('inputTargetField').value);

  let field = props.fields.find(e => e.id === document.getElementById('inputTargetField').value);
  if (field) {
    onClickMarker(field);
  }
}

// 情報ウィンドウ内の原価管理ボタンクリックイベント
function onClickInfoWindowCostButton() {
  // alert(document.getElementById('inputTargetFieldCost').value);

  let field = props.fields.find(e => e.id === document.getElementById('inputTargetFieldCost').value);
  if (field) {
    onClickMarkerCost(field);
  }
}

// 情報ウィンドウ内の生育管理ボタンクリックイベント
function onClickInfoWindowGrowthButton() {
  // alert(document.getElementById('inputTargetFieldGrowth').value);

  let field = props.fields.find(e => e.id === document.getElementById('inputTargetFieldGrowth').value);
  if (field) {
    onClickMarkerGrowth(field);
  }
}

// 住所検索処理
function searchAddress() {
  const geocoder = new window.google.maps.Geocoder();

  geocoder.geocode({
    address: searchKeyword.value
  }, function(results, status) {
    if (status == window.google.maps.GeocoderStatus.OK) {
      const bounds = new window.google.maps.LatLngBounds();
      if (results[0].geometry) {
        // 緯度経度を取得
        var latlng = results[0].geometry.location;
        // 検索結果地が含まれるように範囲を拡大
        bounds.extend(latlng);
      }
      map.fitBounds(bounds);
    }
  });
}

defineExpose({
  reloadOverlay,
  moveMapCenter
});
</script>

<template>
  <!-- 制御用（非表示） -->
  <input class="d-none" id="inputTargetField" type="text">
  <button class="btn d-none" type="button" id="btnInfoDetail" @click="onClickInfoWindowButton()"></button>

  <!-- 制御用（非表示） -->
  <input class="d-none" id="inputTargetFieldCost" type="text">
  <button class="btn d-none" type="button" id="btnInfoDetailCost" @click="onClickInfoWindowCostButton()"></button>

  <!-- 制御用（非表示） -->
  <input class="d-none" id="inputTargetFieldGrowth" type="text">
  <button class="btn d-none" type="button" id="btnInfoDetailGrowth" @click="onClickInfoWindowGrowthButton()"></button>

  <!-- 検索ボタン -->
  <form class="input-group search-content z-2" role="search" @submit.prevent="searchAddress()">
    <input class="form-control me-0" id="inputSearch" type="search" placeholder="Search" aria-label="Search" v-model="searchKeyword">
    <button class="btn btn-sm btn-dark" type="submit"><i class="bi bi-search"></i></button>
  </form>

  <!-- GoogleMAP -->
  <div class="map z-1" id="map"></div>
</template>

<style scoped>
.map {
  width: 100%;
  height: 100%;
}
.search-content {
  position: absolute;
  top: 98%;
  left: 50%;
  transform: translate(-50%, -98%);
  width: 400px;
}
@media (max-width: 767px) {
  .search-content {
    width: 300px;
  }
}
</style>

<style>
.map-marker-label {
  color: white !important;
  text-shadow: 1px 1px 2px black;
}

button.gm-ui-hover-effect {
  width: 36px !important;
  height: 24px !important;

  span {
    margin-top: 0px !important;
  }
}
</style>
